import useTranslation from 'next-translate/useTranslation'
import { apiPost } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'

const useTransactionComments = () => {
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()

  const postComment = async (params) => {
    const response = await apiPost('transaction/comments', params)

    if (response && response.error) {
      toastError(response.error)
    } else if (!params.isTrack) {
      if (response?.broker) {
        toastSuccess(t('toast:commentSentForBroker', { broker: response.broker }))
      } else if (response?.user) {
        toastSuccess(t('toast:commentSent', { user: response.user }))
      } else {
        toastSuccess(t('transaction:commentSaved'))
      }
    }

    return response
  }

  return { postComment }
}

export default useTransactionComments
